module.exports = __webpack_public_path__ + "static/jasmine-42f9fd7d20e7209eb21a27ab7a946c2a.jpg";